"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import GroupCardActionFooter from "./utils/GroupCardActionFooter";
import { ApiRateMatter } from "@/generated/models/ApiRateMatter";
export default function GroupCardActionWrapper(t0) {
  const $ = _c(26);
  const {
    loading,
    disabled,
    addingRates,
    doneMembersCount,
    membersCount,
    matter,
    onSave,
    onCancel,
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      [ApiRateMatter.Rep]: "Rep",
      [ApiRateMatter.Cic]: "NIC"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const MATTER_LABEL = t1;
  let t2;
  if ($[1] !== doneMembersCount || $[2] !== membersCount) {
    t2 = () => {
      if (typeof membersCount !== "number" || typeof doneMembersCount !== "number") {
        return "0%";
      }
      return `${doneMembersCount / membersCount * 100}%`;
    };
    $[1] = doneMembersCount;
    $[2] = membersCount;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const getProgress = t2;
  const [progress, setProgress] = useState(getProgress());
  let t3;
  if ($[4] !== getProgress) {
    t3 = () => {
      setProgress(getProgress());
    };
    $[4] = getProgress;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== doneMembersCount || $[7] !== membersCount) {
    t4 = [membersCount, doneMembersCount];
    $[6] = doneMembersCount;
    $[7] = membersCount;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  useEffect(t3, t4);
  let t5;
  if ($[9] !== addingRates || $[10] !== children || $[11] !== doneMembersCount || $[12] !== matter || $[13] !== membersCount || $[14] !== progress) {
    t5 = addingRates ? <div><p className="tw-mb-0 tw-text-base tw-text-iron-100 tw-font-semibold">{MATTER_LABEL[matter]} Progress</p><p className="tw-mt-1 tw-text-iron-400 tw-text-sm">Please do not leave the page or close this window until the process is complete.</p><p className="tw-mt-4 tw-mb-0 tw-text-xl tw-text-primary-400 tw-font-bold">{doneMembersCount}/{membersCount}</p><div className="tw-mt-2 tw-w-full tw-bg-iron-700 tw-rounded-full tw-h-3"><div className="tw-bg-primary-400 tw-h-3 tw-rounded-full" style={{
          width: progress,
          transition: "width 0.5s ease-out"
        }} /></div></div> : children;
    $[9] = addingRates;
    $[10] = children;
    $[11] = doneMembersCount;
    $[12] = matter;
    $[13] = membersCount;
    $[14] = progress;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t5) {
    t6 = <div className="tw-px-4">{t5}</div>;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== disabled || $[19] !== loading || $[20] !== onCancel || $[21] !== onSave) {
    t7 = <GroupCardActionFooter onCancel={onCancel} loading={loading} disabled={disabled} onSave={onSave} />;
    $[18] = disabled;
    $[19] = loading;
    $[20] = onCancel;
    $[21] = onSave;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== t6 || $[24] !== t7) {
    t8 = <div className="tw-pt-4 tw-pb-3 tw-flex tw-flex-col tw-h-full tw-gap-y-4 tw-divide-y tw-divide-solid tw-divide-x-0 tw-divide-iron-700 tw-relative">{t6}{t7}</div>;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  return t8;
}